import type { EntityLayerType } from 'types/graphql'

/** Non-Parcel: `entityName` as-is.
 * Parcel: `Parcel ${trimmedName}` (trim first to avoid double-space from leading whitespace). */
export const conditionEntityLabel = (entityName: string, entityType: EntityLayerType): string =>
  entityType !== 'Parcel' ? entityName : `Parcel ${entityName.trim()}`.trim()
